import React from 'react';

export default function StatCard({ icon: Icon, label, value, sub, color = '#D4870A' }) {
  return (
    <div className="bg-white rounded-lg p-4 border border-saffron-100/50 shadow-card-lift" data-testid={`analytics-stat-${label.toLowerCase().replace(/\s+/g, '-')}`}>
      <div className="w-8 h-8 rounded-lg flex items-center justify-center mb-2" style={{ backgroundColor: color + '15' }}>
        <Icon size={16} style={{ color }} />
      </div>
      <p className="font-display text-2xl font-bold text-earth-dark">{value}</p>
      <p className="text-[10px] text-earth/50 font-sans">{label}</p>
      {sub && <p className="text-[9px] text-earth/30 font-sans mt-0.5">{sub}</p>}
    </div>
  );
}
